/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import * as React from "react";
import Icon from "./Icon";

export default class Card extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            collapsed: false
        };
    }

    componentDidMount() {
        if (this.props.collapse)
            this.setState({ collapsed: true });
    }

    collapse = () => {
        if (this.props.isCollapse) {
            const prev = this.state.collapsed;
            this.setState({ collapsed: !this.state.collapsed });
            if (!prev) this.props.onHide?.();
            else this.props.onShow?.();
        }
    }

    render() {
        return (<div className={'card mb-3' + (this.props.className ? ' ' + this.props.className : '')} style={this.props.style} onClick={this.props.onClick} role={this.props.onClick ? 'button' : null}>
            {this.props.title ? (
                <div className="card-header" onClick={this.collapse}>
                    {this.props.imgSrc ? (<img src={this.props.imgSrc} alt="" className="d-block img-fluid float-end" style={{ maxHeight: '1.35rem' }} />) : ''}
                    <div className="d-flex justify-content-between">
                        <div><h5 className="card-title">{this.props.title}</h5></div>
                        {this.props.headerButtons && <div>{this.props.headerButtons}</div>}
                        {this.props.isCollapse && <div role="button">
                            {this.state.collapsed ? <Icon icon="faCaretDown" /> : <Icon icon="faCaretUp" />}
                        </div>}
                    </div>

                </div>) : ''}
            {!this.state.collapsed && <div className="card-body">
                {this.props.children}
            </div>}
        </div>);
    }
}